import { AudiencePageTemplate } from '@/components/AudiencePageTemplate'
import { getAudienceSegment } from '@/data/whoWeServe'

export default function YoungArtistProgramsPage() {
  return <AudiencePageTemplate segment={getAudienceSegment('young-artist-programs')} />
}
